import { LabelProps, Label } from './Label';
export function LabelBody(props: LabelProps) {
    return <Label variant="text-body" {...props} />;
}
